<template>
    <div id="containerFio" class="textfieldScreen">
        <div class="leftContent">
            <custom-header :img-number="3"></custom-header>
        </div>
        <div class="rightContent" >
            <div class="headBlock">
                <custom-header />
            </div>
            <div class="wrap textfieldScreen_content">
                <div class="grow"></div>
                <h2 v-html="$ml.get('setFioTitleReg')"></h2>
                <p v-html="$ml.get('startRegText')"></p>

                <mdc-textfield
                        id="mdcLastName"
                        v-model="lastName"
                        :isValid="lastNameValid"
                        :placeholder="$ml.get('setLastNameLableReg')"
                        :errorMessage="fullNameValid ? $ml.get('setFioErrorMessage') : ''"
                        required
                        :maxlength="30"
                        @keydown.native.enter="next"
                />

                <mdc-textfield
                        id="mdcFirstName"
                        v-model="firstName"
                        :isValid="firstNameValid"
                        :placeholder="$ml.get('setFirstNameLableReg')"
                        :errorMessage="fullNameValid ? $ml.get('setFioErrorMessage') : ''"
                        required
                        :maxlength="30"
                        @keydown.native.enter="next"
                />

                <mdc-textfield
                        id="mdcMiddleName"
                        v-model="middleName"
                        :isValid="middleNameValid"
                        :placeholder="$ml.get('setMiddleNameLabelReg')"
                        :errorMessage="fullNameValid ? $ml.get('setFioErrorMessage') : ''"
                        required
                        :maxlength="30"
                        @keydown.native.enter="next"
                />
                <div class="errorText" v-if="!fullNameValid">{{$ml.get('setFioErrorMessage')}}</div>
                <div class="grow"></div>
                <div class="bottom">
                    <div class="left">
                        <custom-button
                                :button-text="$ml.get('back')"
                                back
                                :action="back"
                        ></custom-button>
                    </div>
                    <div class="right">
                        <custom-button
                                :button-text="$ml.get('next')"
                                success
                                :disabled="nextDisabled"
                                :action="next"
                        ></custom-button>
                    </div>

                </div>
            </div>
        </div>
    </div>

</template>

<script>
    import Vue from 'vue'
    import MdcTextfield from '../../../components/ui/mdc-textfield.vue'

    import CustomHeader from "../../../components/ui/custom-header";
    import LoginInput from "../../../components/ui/login-input";
    import CustomButton from "../../../components/ui/custom-button";
    import {default as Profile, filteredName, isWrongFullName} from "../../../helpers/profile";

    export default {
        name: "setFio",
        components: {CustomButton, LoginInput, CustomHeader, MdcTextfield},
        data() {
            return {
                lastName: Profile.lastName,
                firstName: Profile.firstName,
                middleName: Profile.middleName,

                isNotValid: false,
                isNotValidMessage: '',
                lastNameValid: true,
                firstNameValid: true,
                middleNameValid: true,
                fullNameValid: true,
            }
        },

        computed: {
            fullName: function () {
                return (this.lastName.trim() + ' ' + this.firstName.trim() + ' ' + this.middleName.trim()).trim()
            },

            nextDisabled: function () {
                return !this.lastName.trim() || !this.firstName.trim() || !this.middleName.trim();
            },
        },

        created() {
            let isMobile = window.innerWidth < 600;
            if (isMobile) {
                this.$router.replace({ name: 'RegistrationLastName'});
            }
        },

        watch: {
            lastName: function (val) {
                Vue.nextTick(()=>{
                    this.lastName = filteredName(val);
                });
            },
            firstName: function (val) {
                Vue.nextTick(()=>{
                    this.firstName = filteredName(val);
                });
            },
            middleName: function (val) {
                Vue.nextTick(()=>{
                    this.middleName = filteredName(val);
                });
            }
        },

        methods: {
            next: function () {
                if (!this.lastName.trim() || !this.firstName.trim() || !this.middleName.trim() || isWrongFullName(this.fullName)) {
                    if (!this.lastName.trim())
                        this.lastNameValid = false;
                    if (!this.firstName.trim())
                        this.firstNameValid = false;
                    if (!this.middleName.trim())
                        this.middleNameValid = false;
                    if (isWrongFullName(this.fullName)) {
                        this.fullNameValid = false;
                        this.lastNameValid = false;
                        this.firstNameValid = false;
                        this.middleNameValid = false;
                        setTimeout(()=>{
                            this.lastNameValid = true;
                            this.firstNameValid = true;
                            this.middleNameValid = true;
                            setTimeout(()=>{
                                this.fullNameValid = true;
                            }, 400)
                        }, 2500)
                    }
                    return;
                }
                Profile.setData({
                    lastName: this.lastName,
                    firstName: this.firstName,
                    middleName: this.middleName
                });
                this.$router.push({ name: 'RegistrationStartBirthday'});
            },
            back: function () {
                this.$router.back();
            }
        },
    }
</script>

<style lang="scss" scoped>
    .textfieldScreen_content {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        min-height: calc(100vh - 150px);
        p { text-align: left; }
        h2 { margin-bottom: 42px; }
        .errorText {
            color: #b00020;
            font-weight: 300;
        }
    }
    @media (min-width: 601px) and (max-width: 750px) {
        .textfieldScreen_content {
            height: calc(100vh - 220px);
            max-height: 700px;
        }
    }
    @media (min-width: 751px) {
        .textfieldScreen_content {
            height: calc(100vh - 220px);
            max-height: 700px;
        }
    }
</style>